





















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';
import { FileLayoutQuery, ObjectBase } from '../../tenant/common';


@Component
export default class ListViewMenuBar extends Vue {
  @Prop() public listView: Components.ListView;
  @Prop({default:true}) public edit:boolean;
  @Prop({default:true}) public add:boolean;
  @Prop({default:true}) public copy:boolean;
  @Prop({default:true}) public del:boolean;
  @Prop({default:true}) public favorite:boolean;
  @Prop({default:true}) public workflow:boolean;
  @Prop({ default: false }) public electronicBookMode: boolean;
  @Prop({ default: null }) public reportHtml?: string;
  @Prop({ default: null }) public getKeyValue: (item: any) => string;
  @Prop({ default: null }) public voucherImportQuery:Common.VoucherImportQuery;

  public exportLayouts: Common.FileLayout[] = new Array();
  public importLayouts: Common.FileLayout[] = new Array();  

  public reports: Array<Common.ReportTemplate> = new Array();
  public mailReports: Array<Common.ReportTemplate> = new Array();
  public isShowMail: boolean = false;
  public created() {
    if (this.listView.title) {

      //パフォーマンスの観点からクエリを統合
      var query = new Common.ListViewMenuQuery();
      query.viewName = this.listView.title;
      this.$api.execute(query).then(response =>{
          var result = response as Common.ListViewMenuResult;
          this.reports = result.reportTemplates;
          this.mailReports = result.reportTemplates.filter(obj => obj.sendMail > 0); // 一覧メニューでの表示制御はテナント設定に委譲
          this.isShowMail = (this.$api.tenantSettings?.enableListMenuMail ?? true) && this.mailReports.length > 0 // 管理サイトにはtenantSettingsがない
          var exportItems = new Array();
          var importItems = new Array();
          result.fileLayouts.forEach(layout=>{
              if ((layout.fileMode & Common.fileLayoutModes.export) != 0) exportItems.push(layout);
              if ((layout.fileMode & Common.fileLayoutModes.import) != 0) importItems.push(layout);           
          });
          this.exportLayouts = exportItems;
          this.importLayouts = importItems;                
      });

      // var query = new Common.ReportTemplateViewQuery();
      // query.viewName = this.listView.title;
      // this.$api.execute(query).then(response => {
      //   this.reports = response.result;
      // });

      // var query2 = new Common.FileLayoutQuery();
      // query2.viewName = this.listView.title;
      // query2.loadMenu = true;
      // this.$api.execute(query2).then(response => {
      //   var exportItems = new Array();
      //   var importItems = new Array();
      //   (response.result as Array<Common.FileLayout>).forEach(layout=>{
      //       if ((layout.fileMode & Common.fileLayoutModes.export) != 0) exportItems.push(layout);
      //       if ((layout.fileMode & Common.fileLayoutModes.import) != 0) importItems.push(layout);           
      //   });
      //   this.exportLayouts = exportItems;
      //   this.importLayouts = importItems;         
      // });
    }
  }

  public onMenuMounted(target: any, tooltip: string){
      this.$api.tooltip.mount(this, target as Element,tooltip);          
  }
  public onReportGenerate(index: number) {
    var template = this.reports[index];
    this.$api.issueGA4event(this.$route.path,template.isSystemOwned ? '帳票出力(' + template.reportName + ')' : '帳票出力(ユーザー帳票)'); //GA4イベント
    if (template.componentName) {
      //コンポーネントを動的にロードする
      var ctor = this.$api.getReportNamespace()[template.componentName];
      let clazz = Vue.extend(ctor);
      let instance = new clazz({
        propsData: {
          template: template,
        },
      }).$mount();
      instance.$on('hidden', () => {
        //destroyできない
        instance.$el.parentElement.removeChild(instance.$el);
        instance.$destroy();
      });
      this.$el.appendChild(instance.$el);
    } else {
      //選択行だけを渡す場合もある
      // var query = new Common.ReportQuery(template.queryName, this.listView.params);
      // query.templateId = template.id;
      // this.$api.download(query);

      if (this.listView.selectedItems.length == 0){
        this.$api.modal.show("無効な操作","出力対象の行をチェックしてください",true,null);
      } else {
        this.checkedMultiple = this.listView.selectedItems.length > 1;
        this.onCollectPdf = this.listView.selectedItems.length == 1 ? false : !this.electronicBookMode;
        this.onExportSystemLog = false;
        this.onExceFormat = false;
        this.targetTemplate = template;
        this.showReportStyle = true;
        this.designationReport = false;
        this.designationReportTemplateId = null;
        this.showAtcDesignationReportTemplate = false;
        // var query = new Common.ReportQuery2(template.queryName, this.listView.selectedItems);
        // query.templateId = template.id;
        // this.$api.download(query);    
      }
    }
  }
  public onDesignationReportGenerate() {
      if (this.listView.selectedItems.length == 0){
        this.$api.modal.show("無効な操作","出力対象の行をチェックしてください",true,null);
        return;
      } 
      this.checkedMultiple = this.listView.selectedItems.length > 1;
      this.onCollectPdf = false;
      this.onExportSystemLog = false;
      this.onExceFormat = false;
      this.showReportStyle = true;
      this.designationReport = true;
      this.designationReportTemplateId = null;
      this.showAtcDesignationReportTemplate = this.listView.selectedItems.filter(obj=>obj.designationReportTemplateId == null || obj.designationReportTemplateId == 0).length > 0;
  }

  public showReportStyle:boolean = false;
  public onExceFormat: boolean = false;
  public checkedMultiple: boolean = false;
  public onCollectPdf: boolean = false;
  public onExportSystemLog: boolean = false;
  public targetTemplate: Common.ReportTemplate;

  public designationReport: boolean = false;  // 得意先指定帳票
  public showAtcDesignationReportTemplate: boolean = false; // 指定帳票未設定あり
  public designationReportTemplateId: number = null;

  public onReportStyleSelected(event: any){
    if (!this.$refs.designationReportTemplate || (this.$refs.designationReportTemplate as Components.AutoComplete).validator.validate()){
      this.showReportStyle = false;
      var template = this.targetTemplate;

      if(this.designationReport == true){
        this.designationReport = false;
        const designationReportTemplate = this.reports.filter(obj=>obj.id == this.designationReportTemplateId)[0];
        const itemLength = this.listView.selectedItems.length;
        const asyncInForLoop = async () => {
          for (let i = 0; i < itemLength; i++) {
            var template = this.reports.filter(obj=>obj.id == this.listView.selectedItems[i].designationReportTemplateId)[0];
            if(!template) template = designationReportTemplate;
            var items = new Array();
            items.push(this.listView.selectedItems[i]);
            var query = new Common.ReportQuery2(template.queryName, items);
            query.templateId = template.id;
            query.onExcelFormat = this.onExceFormat;
            query.onExportSystemLog = this.onExportSystemLog;
            await this.$api.download(query);
          }
        }
        asyncInForLoop();
      }
      else if(this.onCollectPdf == false){
        const itemLength = this.listView.selectedItems.length;
        const asyncInForLoop = async () => {
          for (let i = 0; i < itemLength; i++) {
            var items = new Array();
            items.push(this.listView.selectedItems[i]);
            var query = new Common.ReportQuery2(template.queryName, items);
            query.templateId = template.id;
            query.onExcelFormat = this.onExceFormat;
            query.onExportSystemLog = this.onExportSystemLog;
            await this.$api.download(query);
          }
        }
        asyncInForLoop();
      }else{
        var query = new Common.ReportQuery2(template.queryName, this.listView.selectedItems);
        query.templateId = template.id;
        query.onExcelFormat = this.onExceFormat;
        query.onExportSystemLog = this.onExportSystemLog;
        this.$api.download(query);    
      }
    }else{
      event.preventDefault();
      return;
    }
  }
  public onExcelFormatRadioChanged(){
    // 電子帳簿保存法対応時、PDF出力する場合は個別のみ
    if(this.onExceFormat == false && this.electronicBookMode == true)  this.onCollectPdf = false;
  }
  //***** エクスポート処理 ******  
  public exportLayoutId: number = null;
  public showExportStyle:boolean = false;
  public onlySelectedItems:boolean = true;
  public onExport(layoutId:number){
    this.onlySelectedItems = true;
    this.exportLayoutId = layoutId;
    this.showExportStyle = true;
  }  

  public onExportExecute(){
    this.showExportStyle = false;
    this.listView.onExport(this.exportLayoutId,this.onlySelectedItems);
  }

  //***** 得意先指定帳票メール送信前準備 ******
  public isShowSelectDesignationReportSending: boolean = false;
  public isMultipleReportSend: boolean = false;
  public designationReportUnspecifiedId: number = null;

  public beforeDesignationReportSend(): void {
    if (this.listView.selectedItems.length == 0) {
        this.$api.modal.show("無効な操作","送信対象の伝票をチェックしてください",true,null);
        return;
    }
    this.$api.issueGA4trackevent(this.$route.path, '得意先指定帳票メール送信：開始');
    this.designationReportUnspecifiedId = null;
    this.reportTemplate = null;
    this.isShowSelectDesignationReportSending = this.listView.selectedItems.filter(item => {
        //メール送信可能でない帳票が指定されている場合、nullを入れる（mailReportsには既に送信可の帳票のみが抽出されている）
        if (!this.mailReports.some(report => report.id == item.designationReportTemplateId)) item.designationReportTemplateId = null;
        return item.designationReportTemplateId == null;
      }).length > 0;
    if (!this.isShowSelectDesignationReportSending) this.onDesignationReportSend(event);
  }

  public async onDesignationReportSend(event: any) {
    if (this.isShowSelectDesignationReportSending && !(this.$refs.designationReportUnspecifiedId as Components.AutoComplete).validator.validate()) {
      event.preventDefault();
      return;
    } 
    this.isShowSelectDesignationReportSending = false;
    // StateObjectにEmailInfoが定義されていることを利用してtemplateIdに伝票ごとの帳票idをセットする
    this.listView.selectedItems.forEach(item => {
      let emailInfo: Common.EmailInfo = new Common.EmailInfo();
      if (item.designationReportTemplateId) {
        emailInfo.templateId = item.designationReportTemplateId;
        item.emailInfo = emailInfo;
      } else {
        emailInfo.templateId = this.designationReportUnspecifiedId;
        item.emailInfo = emailInfo;
      }
    });
    // EmailInfoのリスト取得
    this.isMultipleReportSend = true;
    const response = await this.$api.execute(new Common.EmailInfoQuery((this.listView.selectedItems[0] as ObjectBase).className, this.listView.selectedItems, this.mailReports[0].id, this.isMultipleReportSend));
    // ↑this.isMultipleReportSend=trueなので、this.mailReports[0].idは何にも利用されない
    this.emailInfos = response?.result;
    if (this.emailInfos) {
      this.emailInfos.forEach(info => info.reportTemplate = this.mailReports.find(report => report.id == info.templateId)); // infoごとに帳票をセット(揮発性)
    }
    this.isMailInfoDialogVisible = true;
    this.isSendReportMail = false; // GAイベントを正しく集計するため
  }

  public cancelMail() {
    this.isMultipleReportSend = false;
    this.isSendReportMail = false;
    this.designationReportUnspecifiedId = null;
  }

  //***** メール内容確認 ******
  public isMailInfoDialogVisible : boolean = false;
  public emailInfos:any[] = null;
  public reportTemplate:Common.ReportTemplate=null;
  public onReportSend(index: number){
    if (this.listView.selectedItems.length == 0)  {
      this.$api.modal.show("無効な操作","送信対象の伝票をチェックしてください",true,null);
    } else {
      this.reportTemplate = this.mailReports[index];
      this.$api.issueGA4trackevent(this.$route.path, '帳票メール送信：開始');
      this.$api.issueGA4event(this.$route.path,this.reportTemplate.isSystemOwned ? 'メール送信(' + this.reportTemplate.reportName + ')' : 'メール送信(ユーザー帳票)'); //GA4イベント
      // メールデータ読み込み
      this.$api.execute(new Common.EmailInfoQuery((this.listView.selectedItems[0] as ObjectBase).className,this.listView.selectedItems,this.reportTemplate.id)).then(queryResult => {
        let res = queryResult as Common.LoadResult;
        this.emailInfos = res ? res.result : null;
        // (this.$refs.mailInfomation as Components.ListDialog).showDialog();
        this.isMailInfoDialogVisible = true;
        this.isSendReportMail = false; // GAイベントを正しく集計するため
      });
    }
  }

  // 帳票テンプレートのポップアップ編集画面
  public showReportTemplateEditor = false;
  public onLinkClicked(item: Common.ReportTemplate){
    this.showReportTemplateEditor = true;
      // let routeData = this.$router.resolve(String.format('/system/ReportTemplate?id={0}', item.id));
      // window.open(routeData.href, '_blank');          
  }
  // 帳票テンプレートのポップアップ編集画面Close処理
  public onReportTemplateEditorClosing(arg : any){
    const obj = ((this.$refs.editor as Components.ReportTemplate).$refs.mainList as Components.ListView).selected;

    if ((obj as Common.ReportTemplate).state != Common.ApprovalStatus.Approved) {
      arg.canceled = true; // ポップアップ画面が消えないようにするために必要
      this.$api.modal.show('無効な操作','編集画面を閉じる前に公開してください。', true,null);      
      return;
    }
    //メールデータ再読み込み
    this.onCounterpartClosed(obj as Common.ReportTemplate);
  }

  public async onCounterpartClosed(obj: any){
      //メールデータを再読み込みするか確認
      await this.$api.modal.showDialog('メール内容更新', 'マスタの情報をメール内容に反映しますか？', false, 'はい', 'いいえ')
      // メールデータ再読み込み
      this.$api.execute(new Common.EmailInfoQuery((this.listView.selectedItems[0] as ObjectBase).className,this.listView.selectedItems, this.isMultipleReportSend ? this.mailReports[0].id : this.reportTemplate?.id, this.isMultipleReportSend)).then(queryResult => {
        let res = queryResult as Common.LoadResult;
        this.emailInfos = res ? res.result : null;
        if (this.emailInfos && this.isMultipleReportSend) {
          this.emailInfos.forEach(info => info.reportTemplate = this.mailReports.find(report => report.id == info.templateId)); // infoごとに帳票をセット
        }
      });
  }
  //***** メール送信処理 ******
  public async sendMail(event:any){
    let msg = '';
    const numberSending = this.emailInfos.filter(obj => obj.mailAddress).length;
    const numberNotSending = this.emailInfos.length - numberSending;
    if(numberNotSending > 0) {
      if (this.isMultipleReportSend) msg = String.format("得意先指定帳票を添付して、 {0} 件中 {1} 件の取引先に送信します。実行してよろしいですか?", this.emailInfos.length, numberSending);
      else msg = String.format("{0} を添付して、 {1} 件中 {2} 件の取引先に送信します。実行してよろしいですか?",this.reportTemplate?.reportName, this.emailInfos.length, numberSending);
      msg += String.format("\r\n※ {0} 件の取引先にメールアドレスが設定されていません。", numberNotSending);
    }else{
      if (this.isMultipleReportSend) msg = String.format("得意先指定帳票を添付して {0} 件の取引先に送信します。実行してよろしいですか?", numberSending);
      else msg = String.format("{0} を添付して {1} 件の取引先に送信します。実行してよろしいですか?",this.reportTemplate?.reportName, numberSending);
    }
    event.preventDefault();
    await this.$api.modal.showDialog("メール送信",msg,false);
    this.$api.startWaitCusor();
    if (this.isMultipleReportSend) this.$api.issueGA4trackevent(this.$route.path, '得意先指定帳票メール送信：完了');
    else this.$api.issueGA4trackevent(this.$route.path, '帳票メール送信：送信完了'); // GA4イベント
    
    // 50件を超える場合は50件ずつに分割して2回クエリを叩く～LambdaのAsyncペイロード上限は256KB
    if (this.emailInfos.length > 50) {
        const emailInfoFirstHalf = this.emailInfos.slice(0,50);
        const emailInfoSecondHalf = this.emailInfos.slice(50);
        const selectedItemsFirstHalf = this.listView.selectedItems.filter(item => {
          return emailInfoFirstHalf.some(info => info.voucherNo == item.voucherNo);
        });
        const selectedItemsSecondHalf = this.listView.selectedItems.filter(item => {
          return emailInfoSecondHalf.some(info => info.voucherNo == item.voucherNo);
        });

        const resFirst = await this.$api.execute(new Common.ReportSendQuery((this.listView.selectedItems[0] as ObjectBase).className, selectedItemsFirstHalf, this.isMultipleReportSend ? this.mailReports[0].id : this.reportTemplate?.id, emailInfoFirstHalf, this.getKeyValue ? selectedItemsFirstHalf.map(obj=>this.getKeyValue(obj)):null, this.isMultipleReportSend));
        const resSecond = await this.$api.execute(new Common.ReportSendQuery((this.listView.selectedItems[0] as ObjectBase).className, selectedItemsSecondHalf, this.isMultipleReportSend ? this.mailReports[0].id : this.reportTemplate?.id, emailInfoSecondHalf, this.getKeyValue ? selectedItemsSecondHalf.map(obj=>this.getKeyValue(obj)):null, this.isMultipleReportSend));
        
        //システムログへのリンクを表示する
        let links = [new Common.ModalLink(String.format('システムログ ID={0}',resFirst),String.format('/operation/SystemLog?id={0}',resFirst)), new Common.ModalLink(String.format('システムログ ID={0}',resSecond),String.format('/operation/SystemLog?id={0}',resSecond))];
        this.$api.modal.show('処理結果','メール送信処理が開始されました。\r\n送信結果は、通知のメール、または以下のリンクから確認できます。',true,null,links,null,null,
          "<br><p class='cx_dialog_tips'>※ワークフローアクションに帳票を設定することで、自動でメールを送信することが可能になります。　詳細は<a href='https://support.s-flow.net/ja/articles/8259490' target='_blank'>サポートサイト</a>をご確認ください。</p>");
        this.isMailInfoDialogVisible = false;
    } else {
      await this.$api.execute(new Common.ReportSendQuery((this.listView.selectedItems[0] as ObjectBase).className, this.listView.selectedItems, this.isMultipleReportSend ? this.mailReports[0].id : this.reportTemplate?.id, this.emailInfos, this.getKeyValue ? this.listView.selectedItems.map(obj=>this.getKeyValue(obj)):null, this.isMultipleReportSend)).then(res=>{
          //システムログへのリンクを表示する
          var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
          this.$api.modal.show('処理結果','メール送信処理が開始されました。\r\n送信結果は、通知のメール、または以下のリンクから確認できます。',true,null,links,null,null,
            "<br><p class='cx_dialog_tips'>※ワークフローアクションに帳票を設定することで、自動でメールを送信することが可能になります。　詳細は<a href='https://support.s-flow.net/ja/articles/8259490' target='_blank'>サポートサイト</a>をご確認ください。</p>");
          this.isMailInfoDialogVisible = false;
        });
    }
    this.isMultipleReportSend = false;
    this.$api.closeWaitCursor();
  }
  


//***** 一括ワークフロー操作 ******

  public isWorkflowDialogVisible : boolean = false;
  public workflowMessage: string = '';
  public workflowStateIdTo:number = null;
  public workflowActions: Common.WorkflowAction[];
  public workflowStates:Common.BindItem[];
  public workflowAction: Common.WorkflowAction;
  public isSendReportMail: boolean = false;
  public templateId: number = null;
  public templateName: string = null;
  public isShowSendReportSetting: boolean = false;

  public get isStateObject() {
    const temp = this.$api.createInstance(this.listView.modelName) ;   
    return this.workflow && (temp instanceof Common.StateObject);
  }
  public getWorkflowStates(){
    return this.workflowStates;
  }
  public showWorkflowDialg(){

    //ワークフロー・状態が同じで所有者に割り当てられていること
    // ダイアログ表示前バリデーション
    if(this.listView.selectedItems.length == 0){
      this.$api.modal.show('無効な操作', '伝票を選択して下さい。', true, null);
      return;
    }        
    var firstItem = this.listView.selectedItems[0] as Common.StateObject;
    if(this.listView.selectedItems.filter(obj => (obj as Common.StateObject).workflowCode != firstItem.workflowCode ||  (obj as Common.StateObject).workflowId != firstItem.workflowId).length > 0){
      this.$api.modal.show('無効な操作', '同じワークフローの伝票を選択してください。', true, null);
      return;
    }
    if(this.listView.selectedItems.filter(obj => (obj as Common.StateObject).workflowStateId != firstItem.workflowStateId).length > 0){
      this.$api.modal.show('無効な操作', '複数の伝票を処理する場合は、「状態」が同じものを選択してください。', true, null);
      return;
    }            
    if(this.listView.selectedItems.filter(obj => this.$api.perms.hasWorkflowPermission((obj as Common.StateObject).workflowHolder) ==false).length > 0){
      this.$api.modal.show('無効な操作', '権限をもつ伝票を選択してください。', true, null);
      return;
    }        
    this.workflowActions = this.$api.perms.getWorkflowActions(firstItem.workflowCode, firstItem.workflowId,firstItem.workflowStateId);
    this.workflowStates =  this.workflowActions.map(obj => new Common.BindItem(obj.stateIdTo,obj.actionName));
    const state = this.$api.perms.getWorkflowState(firstItem.workflowCode, firstItem.workflowId,firstItem.workflowStateId);
    //開始点以外でUserStatusの場合に差戻しボタンを表示する
    if((state.type & Common.StateTypes.EntryStatus) != Common.StateTypes.EntryStatus && (state.type & Common.StateTypes.UserStatus) == Common.StateTypes.UserStatus)
      this.workflowStates.push(new Common.BindItem(-1,'差戻'));

    if(this.workflowStates.length == 0){
      // this.$api.modal.show('無効な操作', '可能なワークフローアクションがありません', true, null);
      this.$api.modal.show('無効な操作',firstItem.messageOnActionMissing, true, null);
      return;
    }       

    this.workflowMessage = '';
    this.workflowStateIdTo = null;
    this.isWorkflowDialogVisible = true;
  }

  @Watch('workflowStateIdTo')
  public setWorkflowAction() {
    this.workflowAction = this.workflowActions.find(action => action.stateIdTo == this.workflowStateIdTo);
    if (this.workflowAction?.isShowSendReport) {
      this.isShowSendReportSetting = true;
      this.templateId = this.workflowAction?.templateId;
      this.isSendReportMail = this.templateId ? true : false;
    }
    else this.isShowSendReportSetting = false;
  }

  public async getTemplates(action: Common.WorkflowAction):Promise<Common.BindItem[]>{
  const workflowControllerName = action.workflow.controller.name;
    let result = this.$api.execute(new Common.WorkflowReportTemplateQuery(workflowControllerName));
    return result;
 }
  public async getReportTemplates():Promise<Common.BindItem[]>{
    return this.atcReportQuery(this.listView.title);
 }
  public async atcReportQuery(viewName:string):Promise<Common.BindItem[]> {
      var bindItems = new Array();
      var query = new Common.ReportTemplateViewQuery();
      query.viewName=viewName;
      await this.$api.execute(query).then(res => {
          var result = res as Common.LoadResult;
          result.result.forEach(obj =>{
            if (this.isShowSelectDesignationReportSending) {
              if (obj.sendMail > 0) bindItems.push(new Common.BindItem(obj.id, obj.name));
            } else {
              bindItems.push(new Common.BindItem(obj.id,obj.name));
            }
          });
        });
      return Promise.resolve(bindItems);
  }

 @Watch('isSendReportMail')
  public setTemplateId() {
    this.templateId = this.isSendReportMail ? this.workflowAction.templateId : null;
  }

  //***** ワークフロー一括操作のメール送信処理 ******
  public async getEmailInfo(){
    // GA4イベント
    this.$api.issueGA4trackevent(this.$route.path, '一括ワークフロー操作メール送信：送信確認');

    // メールデータ読み込み
    await this.$api.execute(new Common.EmailInfoQuery((this.listView.selectedItems[0] as ObjectBase).className, this.listView.selectedItems, this.templateId)).then(queryResult => {
      const res = queryResult as Common.LoadResult;
      this.emailInfos = res ? res.result : null;
    });

    let msg = '';
    if(this.emailInfos.filter(obj=>!obj.mailAddress).length > 0) {
      msg = String.format("{0} を添付して、 {1} 件中 {2} 件の取引先に送信します。実行してよろしいですか?", this.templateName ,this.emailInfos.length,this.emailInfos.filter(obj=>obj.mailAddress).length);
      msg += String.format("\r\n※ {0} 件の取引先にメールアドレスが設定されていません。",this.emailInfos.filter(obj=>!obj.mailAddress).length);
    }else{
      msg = String.format("{0} を添付して {1} 件の取引先に送信します。実行してよろしいですか?", this.templateName, this.emailInfos.filter(obj=>obj.mailAddress).length);
    }
    await this.$api.modal.showDialog("メール送信",msg,false);
    // メール送信処理はsendしてAPIのPostで行う
  }
  
  public async executeWorkflow(event:any){
    //手動バリデーション
    const control = (this.$refs.workflowAction as any) as Components.IControl;
    if (control.validator.validate() == false) {
      event.cancel();
      return;
    }

    // ワークフローアクションでメール送信確認をONにしているか
    if (this.workflowAction.isShowSendReport) {
      // ワークフローメール送信用に帳票名を取得
      this.templateName = (this.$refs.atcReportTemplate as Components.AutoComplete)?.displayName;
      if (this.isSendReportMail && !this.templateId) {
        event.preventDefault();
        await this.$api.modal.show('無効な操作', '※「送信する帳票」が選択されていません。\r\n　「送信する帳票」を選択するか、\r\n　「帳票メールを送信」のチェックを外してください。', true, null);
        return;
      }
      if (!this.isSendReportMail && this.workflowAction.templateId) {
        // GA4イベント
        this.$api.issueGA4trackevent(this.$route.path, '一括ワークフロー操作メール送信：チェック外してフロー進行');
      }
      if (!this.isSendReportMail) this.isWorkflowDialogVisible = false;
    }

　 //事前処理の定義
    var preProcess = (item:Common.StateObject)=>{
      if (this.workflowMessage){
          const msg = new Common.WorkflowMessage();
          msg.userId = this.$api.auth.userId;
          msg.isNote = false;
          msg.destination = ''; //宛先はサーバー側で更新する
          msg.description = this.workflowMessage;
          msg.timeStamp = null; //新規メッセージをマークする
          item.workflowMessage = msg;
      }
      return item;
    }
    //後続処理の定義~ 利用状況照会画面は表示しない
    var postProcess = (item:Common.StateObject,index : number) => {      
      //現在編集中の行は、onWorkflowを呼び出す(追加処理が実装されている場合がある)
      if (index == this.listView.currentId) (this.listView.$parent as any).onWorkflow(index,item);
      else  this.$set(this.listView.items, index, item);
      };

    //stateIdが-1の場合はsendBack
    var lastIndex = this.listView.selectedItems.length -1;
    if (this.workflowStateIdTo == -1) {
      this.listView.selectedItems.reduce(async (previous, obj,index) => {
        await previous;
        var itemIndex = this.listView.items.indexOf(obj); 
        await this.$api.sendBack(preProcess(obj), index== lastIndex).then(obj => postProcess(obj,itemIndex));
      }, undefined);
    }
    else {
      // メール送信準備
      if (this.isSendReportMail) {
        event.preventDefault();
        await this.getEmailInfo();
        this.isWorkflowDialogVisible = false;
        // GA4イベント
        this.$api.issueGA4trackevent(this.$route.path, '一括ワークフロー操作メール送信完了(' + this.templateName +')');
      }
      await this.listView.selectedItems.reduce(async (previous, obj,index) => {
        await previous;
        var itemIndex = this.listView.items.indexOf(obj);
        if (this.isSendReportMail) {
          let emailInfo: Common.EmailInfo = null;
          // 管理サイト対応(PartnerPayment)～emailInfoがnullのままAPIを叩き従来のメール送信処理に進む
          if (obj.className != 'PartnerPayment') emailInfo = await this.emailInfos?.find(info => info.voucherNo == obj.voucherNo);
          if (emailInfo) {
            emailInfo.isSend = this.isSendReportMail;
            emailInfo.templateId = this.templateId;
            obj.emailInfo = emailInfo;
          } 
        } else {
          let emailInfo: Common.EmailInfo = new Common.EmailInfo();
          obj.emailInfo = emailInfo;
        }
        await this.$api.send(preProcess(obj), this.workflowStateIdTo, index== lastIndex).then(obj => postProcess(obj,itemIndex));
      }, undefined);
     
      if (this.isSendReportMail) {
          let links = [new Common.ModalLink('システムログ', '/operation/SystemLog')];
          this.$api.modal.show('処理結果','メール送信処理が開始されました。\r\n送信結果は、通知のメール、または以下のリンクから確認できます。',true,null,links,null,null,
            "<br><p class='cx_dialog_tips'>※ワークフローアクションに帳票を設定することで、自動でメールを送信することが可能になります。　詳細は<a href='https://support.s-flow.net/ja/articles/8259490' target='_blank'>サポートサイト</a>をご確認ください。</p>");
        }
    }
  }
  //***** 一括ワークフロー操作(ここまで) ******  

  
  public setPosition(data: any) {
      var target = data.target as HTMLElement;
      var vue = data.vueTarget as Vue;
      target.setAttribute("style",String.format("left:{0}px;", (vue.$el as any).offsetLeft - vue.$el.parentElement.scrollLeft));

      return data;
    }

  public showVoucherImport:boolean = false;

  public onVoucherImport(){
    this.voucherImportQuery.targetSheet = "入力シート";
    this.showVoucherImport = true;
  }
  public onVoucherImportExecute(){
    if ((this.$refs.sheetName as Components.TextBox).validator.validate() == false) {
      event.preventDefault();
      return;
    }

    const obj = (this.$refs.file as any).files as FileList;
    if (obj.length == 0) {
      this.$api.modal.showDialog('無効な操作','インポートファイルを選択してください',true).then(()=>this.showVoucherImport = true);
      return;
    }
    
    this.$api.upload(this.voucherImportQuery, obj).then(res =>{
      //追加時の処理をコピー(OnSubmit)
      var list = res as Array<any>;
      this.listView.currentId = this.listView.items.length + list.length - 1; //末尾+1
      this.listView.items.push(...list);//onItemsChangedが実行されるので先にcurrentIdを変更する
      (this.listView.$refs.listBox as Components.Grid).resetChecked(); //onItemChanged側で追加を検知できないので手動呼出し
    });
  }
}
